import {cloneDeep as _cloneDeep} from 'lodash';
import ErrorLogModel from "./../../models/ErrorLogModel"
const ErrorLogModule = {
    namespaced: true,
    state: () => ({
        errorLogList: [],
        errorLogItem: _cloneDeep(ErrorLogModel, true),
    }),
    getters: {
        getErrorLogList (state) {
            return state.errorLogList
        },
        getErrorLogItem (state) {
            return state.errorLogItem
        },
    },
    mutations: {
        setErrorLogList(state, payload) {
            state.errorLogList = payload
        },
        setErrorLogItem(state, payload) {
            state.errorLogItem = payload
        },
    },
    actions: {
        setErrorLogList (context, payload) {
            context.commit('setErrorLogList', payload);
        },
        setErrorLogItem (context, payload) {
            context.commit('setErrorLogItem', payload);
        },
    },
}

export default ErrorLogModule;
